<template>
  <v-container fluid class="pa-0">
    <toolbar
      @search="search"
      @adv-search="advancedSearch"
      @clear-search="clearSearch"
    />
    <datatable
      ref="datatable"
      :search="searchObject"
      @approve-user="approveUser"
      @refuse-user="refuseUser"
      @delete-user="deleteUser"
      @put-discount="putDiscount"
      @image-dialog="showImage"
    />
    <photo-dialog ref="photoDialog" />
    <v-dialog v-model="dialogDelete" width="auto">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert class="mb-0" :value="true" type="error">
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete()">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Toolbar from "@/components/ApproveUsers/toolbar.vue";
import Datatable from "@/components/ApproveUsers/datatable.vue";
import PhotoDialog from "@/components/ApproveUsers/photoDialog.vue";

import putRequest from "../api/putRequest";
import deleteRequest from "../api/deleteRequest";

export default {
  components: {
    toolbar: Toolbar,
    datatable: Datatable,
    "photo-dialog": PhotoDialog,
  },
  data: () => ({
    searchObject: {
      type: null,
      data: {},
      dialogDelete: false,
      userToDelete: null,
    },
  }),
  mounted() {},
  methods: {
    search(data) {
      this.searchObject = {
        type: "regularSearch",
        data,
      };
    },
    advancedSearch(data) {
      this.searchObject = {
        type: "advancedSearch",
        data,
      };
    },
    clearSearch() {
      this.searchObject = {
        type: null,
        data: {},
      };
    },
    approveUser(id) {
      putRequest(`/user/shop/status/${id}`, "operation=approve")
        .then(() => {
          const { datatable } = this.$refs;
          datatable.getUsers();
        })
        .catch(() => {});
    },
    refuseUser(id) {
      putRequest(`/user/shop/status/${id}`, "operation=refuse")
        .then(() => {
          const { datatable } = this.$refs;
          datatable.getUsers();
        })
        .catch(() => {});
    },
    putDiscount(data) {
      putRequest(`/user/shop/discount/${data.id}`, `discount=${data.discount}`)
        .then(() => {})
        .catch(() => {});
    },
    deleteUser(id) {
      this.userToDelete = id;
      this.dialogDelete = true;
    },
    confirmDelete() {
      deleteRequest("/user/shop", `id=${this.userToDelete}`)
        .then(() => {
          const { datatable } = this.$refs;
          datatable.getUsers();
        })
        .catch(() => {})
        .finally(() => {
          this.dialogDelete = false;
          this.userToDelete = null;
        });
    },
    showImage(data) {
      const { photoDialog } = this.$refs;
      photoDialog.showImage(data);
    },
  },
};
</script>
